import { Typography } from 'antd';
import styled from '@emotion/styled';
import { PropsWithChildren } from 'react';

export const StyledTextCell = styled(Typography.Text)`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.005em;
  text-align: left;
  color: #232b3a;
`;

type TextCellProps = {
  fallback?: React.ReactNode;
  className?: string;
};

export const TextCell = (props: PropsWithChildren<TextCellProps>) => {
  const { className, children, fallback = '/' } = props;

  return (
    <StyledTextCell className={className}>
      {children || fallback}
    </StyledTextCell>
  );
};
